import {useEffect, useState} from 'react';
import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import {
  Tabs, TabsProps
} from 'antd';
import PageLoader from '../../../../microcomponents/PageLoader';
import PhonePreviewFrame from '../../../../components/PhonePreviewFrame';
import ShopProfilePreview from '../../../../components/Customize/ShopProfilePreview';

export const Route = createFileRoute('/_authenticated/customize')({
  component: RouteComponent,
  pendingComponent: () => <PageLoader />
});

function RouteComponent() {


  const navigate = useNavigate();
  const location = useLocation();


  const tabs: TabsProps['items'] = [
    {
      key: 'profile',
      label: 'Profilo',
      children: <div className={'mb-20'}><Outlet /></div>
      /* icon: <HugeiconsIcon icon={StarFreeIcons} className={'inline-block'} size={12} strokeWidth={1.5}/>*/
    },
    {
      key: 'quick-links',
      label: 'Collegamenti rapidi',
      children: <div className={'mb-20'}><Outlet /></div>
      /*    icon: <HugeiconsIcon icon={Megaphone03FreeIcons} className={'inline-block'} size={12} strokeWidth={1.5}/>*/
    }
  ];


   const [previewScale, setPreviewScale] = useState(1);

   useEffect(() => {
     const handleResize = () => {
       if(window.innerHeight / 800 < 1.1){
         setPreviewScale((window.innerHeight / 800) - 0.1)
       }else if( window.innerWidth / 800 < 1.1){
         setPreviewScale((window.innerWidth / 800) - 0.1)
       }else{
         setPreviewScale(1)
       }

     };
     window.addEventListener('resize', handleResize);
     return () => {
       window.removeEventListener('resize', handleResize);
     };
   }, []);



  return (
    <div className={'p-4 flex m-auto justify-around gap-4 max-w-[1200px]'}>
      <div style={{ maxWidth: '450px', width: '100%' }}>
        <Tabs activeKey={location.pathname === '/customize' ? 'profile' : location.pathname.split('/').pop()}
              onChange={(selected: string) => {
                navigate({ to: selected === 'profile' ? '/customize' : '/customize/' + selected });
              }}
              items={tabs} />
      </div>

      <div className={'w-full justify-center items-start hidden md:flex'}>
        <div className={'sticky top-4'} style={{zoom: previewScale}}>
          <PhonePreviewFrame>
            <ShopProfilePreview />
          </PhonePreviewFrame>
        </div>
      </div>
    </div>

  );
}
